export const SCENES = {
  MENU: 'menu',
  COMBAT: 'combat',
  HOW_TO: 'how-to',
  GAME_OVER: 'game-over',
} as const;

export type SceneKey = (typeof SCENES)[keyof typeof SCENES];

export const GAME_CONFIG = {
  basePlayerSpeed: 150,
  baseEnemySpeed: 135,
  basePlayerDamage: 14,
  baseEnemyDamage: 11,
  particleBurst: 26,
};

export const ARENA = {
  width: 320,
  height: 180,
  groundY: 140,
  centerX: 160,
} as const;

export const UI = {
  font: '8px "Press Start 2P", monospace',
  largeFont: '12px "Press Start 2P", monospace',
  colorPrimary: '#c8ffe2',
  colorAccent: '#7affcb',
  colorWarning: '#ff7d9c',
  shadow: '#04150d',
};
